<template>
  <v-row>
    <v-col sm="12">
      <v-card>
        <v-card-title>
          <!-- <v-icon @click="pushRouteToView('services')" class="mr-4" style="cursor: pointer">
                        mdi-arrow-left
                    </v-icon> -->
          <v-btn
            small
            @click="pushRouteToView('services')"
            class="mr-4 btn-back"
          >
            <v-icon> mdi-arrow-left </v-icon>
            Voltar
          </v-btn>
          <v-icon left>mdi-hair-dryer-outline</v-icon>
          Dados do Serviço
          <v-spacer></v-spacer>
          <v-btn outlined class="btn-del" @click="dialogDeleteService = true">
            <v-icon left>mdi-delete</v-icon>
            Excluir
          </v-btn>

          <v-btn
            outlined
            :class="`${service.active ? 'btn-inactive' : 'btn-active'} mx-2`"
            @click="dialogActiveInactive = true"
          >
              <span v-if="service.active"><v-icon left>mdi-diameter-variant</v-icon>Inativar</span><span v-else><v-icon
              left>mdi-checkbox-marked-circle-outline</v-icon>Ativar</span>
              
            <!--<v-icon left>mdi-pencil</v-icon>
            <span v-if="service.active">Inativar</span
            ><span v-else>Ativar</span> -->
          </v-btn>

          <v-btn
            :to="{ name: 'servicesEdit', params: { id: service.id } }"
            class="btn-edit"
          >
            <v-icon left>mdi-pencil</v-icon>
            Editar
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="text-data-visualization">
          <v-card style="border-left: solid 10px #3d1159 !important">
            <v-card-title> </v-card-title>

            <v-card-text class="text-data-visualization">
              <v-row>
                <v-col md="4" sm="6" xs="12">
                  <b><v-icon>mdi-hair-dryer-outline</v-icon>Serviço:</b>
                  {{ service.name }}
                </v-col>
                <v-col md="4" sm="6" xs="12">
                  <b><v-icon>mdi-currency-usd</v-icon>Valor:</b>
                  {{ service.value | money }}
                </v-col>
                <v-col md="4" sm="6" xs="12" class="font-weight-medium">
                  <b><v-icon>mdi-check</v-icon>Categoria:</b>
                  {{ service.categoryName }}
                </v-col>
              </v-row>
              <v-row>
                <v-col md="12" sm="12" xs="12" xl="12">
                  <b><v-icon>mdi-format-align-justify</v-icon>Descrição:</b>
                  {{ service.desc }}
                </v-col>
              </v-row>
              <v-row>
                <v-col md="12" sm="12" xs="12" xl="12">
                  <b><v-icon></v-icon>Status:</b>
                  {{ service.active | activeText }}
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-alert type="warning" outlined v-show="!service"
          >Nenhum serviço encontrado
        </v-alert>
        <confirm-dialog
          :dialog="dialogActiveInactive"
          :title="`${service.active ? 'INATIVAR ' : 'ATIVAR '} ${service.name}`"
          body="Tem certeza que deseja realizar essa ação?"
          @dialog-event="inactiveActive"
        >
        </confirm-dialog>
        <confirm-dialog
          :dialog="dialogDeleteService"
          :title="`EXCLUIR  ${service.name}`"
          :body="`Tem certeza que deseja excluir o serviço ${service.name} ?`"
          @dialog-event="deleteService"
        >
        </confirm-dialog>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";
import { mask } from "vue-the-mask";
import ConfirmDialog from "@/components/ConfirmDialog";

import {
  SERVICE_ACTIVE,
  SERVICE_DELETE,
  SERVICE_GET,
  SERVICE_INACTIVE,
} from "@/store/actions/service.type";
import {
  SERVICE_RESET_STATE,
  SET_SERVICE_ACTIVE,
} from "@/store/mutations/service.type";
import { CHANGE_PROGRESS } from "@/store/mutations/mutations.type";

export default {
  name: "service",
  directives: { mask },
  props: {
    id: {
      default: 0,
      type: Number,
      required: true,
    },
  },

  components: { ConfirmDialog },
  async beforeRouteUpdate(to, from, next) {
    // Reset state if user goes from /editor/:id to /editor
    // The component is not recreated so we use to hook to reset the state.
    await store.dispatch(SERVICE_RESET_STATE);
    return next();
  },
  async beforeRouteEnter(to, from, next) {
    Promise.all([
      await store.dispatch(SERVICE_RESET_STATE),
      await store.dispatch(SERVICE_GET, to.params.id),
    ]).then(() => {
      next();
    });
  },
  data: () => ({
    //Lista de Usuários
    pagination: {
      sortBy: "name",
    },
    search: "",
    selected: [],
    formIsValid: false,

    dialogActiveInactive: false,
    dialogDeleteService: false,
  }),
  methods: {
    pushRouteToView(route) {
      this.$router.push({ name: route });
    },
    //Methods Lista Usuarios
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.dados.slice();
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    deleteService(status) {
      this.dialogDeleteService = false;
      if (!status) {
        return;
      }
      this.$store.commit(CHANGE_PROGRESS, true);
      this.$store
        .dispatch(SERVICE_DELETE)
        .then(() => {
          this.$store.commit(CHANGE_PROGRESS, false);
          this.snackbar.snackbar = true;
          this.snackbar.color = "success";
          this.snackbar.text = "Excluído com sucesso";

          this.$router.push({
            name: "services",
          });
        })
        .catch(({ response }) => {
          this.$store.commit(CHANGE_PROGRESS, false);
          this.snackbar.snackbar = true;
          this.snackbar.color = "error";
          this.snackbar.text = "Erro ao excluir.";
          // console.log(response.data);
          if (typeof response.data.message !== "undefined") {
            this.snackbar.text = response.data.message;
          }
        });
    },
    inactiveActive(status) {
      this.dialogActiveInactive = false;
      if (!status) {
        return;
      }
      let action = this.service.active ? SERVICE_INACTIVE : SERVICE_ACTIVE;
      this.$store.commit(CHANGE_PROGRESS, true);

      this.$store
        .dispatch(action, this.service.id)
        .then(() => {
          this.$store.commit(CHANGE_PROGRESS, false);
          this.snackbar.snackbar = true;
          this.snackbar.color = "success";
          this.snackbar.text = "Alterado com sucesso";
          this.$store.commit(SET_SERVICE_ACTIVE, !this.service.active);
        })
        .catch(({ response }) => {
          this.$store.commit(CHANGE_PROGRESS, false);
          this.snackbar.snackbar = true;
          this.snackbar.color = "error";
          this.snackbar.text = "Erro ao alterar.";
          // console.log(response.data);
          if (typeof response.data.message !== "undefined") {
            this.snackbar.text = response.data.message;
          }
        });
    },
  },
  mounted() {},
  computed: {
    ...mapGetters(["snackbar", "inProgress", "checkUsers", "service"]),
  },
  watch: {},
};
</script>
